import { createFileRoute } from '@tanstack/react-router'
import { RequirePermission } from '@/components/ui/require-permission'
import { CustomerDetailPage } from '@/features/customers/customer-detail'

export const Route = createFileRoute('/_authenticated/customers/$customerId')({
  component: () => (
    <RequirePermission permission='customers.read'>
      <CustomerDetailPage />
    </RequirePermission>
  ),
})
